<template>
  <div style="width: 100vw; height: 100vh"></div>
</template>

<script>

export default {
  name: "newlogin",
  created() {},
  activated() {},
  mounted() {
    var url = window.location.href;
    if (window.config.type === 1) {
      if (url.indexOf("nameCode=") != -1) {
        var nameCode = url.split("nameCode=")[1];
        if (nameCode) {
          this.autologin(nameCode);
        }
      } else {
        console.log("错误");
        this.logining = false;
        sessionStorage.setItem("errorMessage", "请检查您的URL是否正确或存在");
        this.$router.push("/errorLoginPage");
      }
    } else {
      console.log("无权访问这个地址");
      this.logining = false;
      sessionStorage.setItem("errorMessage", "请检查您的URL是否正确或存在");
      this.$router.push("/errorLoginPage");
    }
  },
  methods: {
    // 点击确认
    autologin(accounts) {
      this.util.post('/autoLogin', {
        accounts: accounts,
      }).then(({ data }) => {
        // console.log(data)
        if (data.code === 200) {
           localStorage.setItem("isLogin", 1); // 存储已登录信息
            localStorage.setItem("UserToken", data.data.UserToken);
            localStorage.setItem("accounts", accounts);
            this.$router.replace({
              path: "/home", // 进入主页
            });
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
  },
  computed: {},
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="less">
</style>
